import { render } from "./GiftsReport.vue?vue&type=template&id=1b6c9a90"
import script from "./GiftsReport.vue?vue&type=script&lang=js"
export * from "./GiftsReport.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__